<template>
<div class="bodybox" id="jiaoanx" style="padding:20px" oncontextmenu="return false" onselectstart="return false" ondragstart="return false" >
<div>
    <el-row :gutter="10">
        <el-col :span="3">
            <div class="dropbox" >
              <span class="el-dropdown-link" style="color: #fff">全部课程</span>
            </div>
            <div class="kelist hang1" v-for="(item,index) in quanke1" :class="{active1:(item.kc_id == kcid)}"
              @click="ke1(item.kc_id)">
                {{item.kc_name}}
            </div>
        </el-col>
        <el-col :span="3">

      <!--<el-dropdown trigger="click" class="dropbox2">-->
      <!--<span class="el-dropdown-link">-->
        <!--所有课程<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
      <!--</span>-->
           <!--<el-dropdown-menu slot="dropdown">-->
                    <!--<el-dropdown-item>未备课</el-dropdown-item>-->
                    <!--<el-dropdown-item>已完成</el-dropdown-item>-->
                <!--</el-dropdown-menu>-->
            <!--</el-dropdown>-->
            <div class="btn-group" style="width: 100%">
                <button type="button" class="btna  dropdown-toggle kezhuang2"
                        data-toggle="dropdown" style="width: 100%">
                   {{kecheng2}}<span class="caret"></span>
                </button>
                <ul class="dropdown-menu dropm1" role="menu"  style="min-width: 0;margin: 0">
                    <li @click="shai(1)"><a href="javascript:;" >未备课</a></li>
                    <li @click="shai(1)"><a href="javascript:;" >备课中</a></li>
                </ul>
            </div>

            <div class="kelist hang1" v-for="(item,index) in quanke2" :class="{active2:(item.id == iid)}"
             @click="ke2(item.id)">
                {{item.title}}
            </div>
        </el-col>

        <el-col :span="18">
            <div>
                <div style="padding: 0 20px; ">
                    <i style="color: rgb(253, 176, 106);"><span class="fa fa-eye"></span> <span>浏览次数<span>{{ydrs}}</span> 次</span></i>
                    <i style="color: rgb(121, 196, 199);"><span class="fa fa-star-o" style="padding-left: 28px;"></span> <span>收藏<span>{{shouc}}</span>次</span></i>
                </div>

                <div class="conTitle text-center jiaoxt" >
                    <span style="font-size: 24px; padding-left: 20%;">{{title}}</span>
                    <span style="color: rgb(153, 153, 153); font-size: 12px;">(<span>{{kechengname}}</span>)</span>
                     <button class="zidBtn zidy" :class="is_bk == 1 ? 'btn_back' : ''" style="float: right;" @click="wanb">完成备课</button>
                    <button class="zidBtn zidg" :class="is_sc == 1 ? 'btn_back' : ''" style="float: right;" v-on:click="shez">设置重点</button>

                </div>
            </div>
            <el-row>
                <el-col :span="12" style="padding-right: 4px">
                    <div class="titleListBox">
                        <div class="titleList" style="cursor: auto;">
                            <span>开场舞</span>
                        </div>
                        <div :aud="audios" v-on:click="yin1($event)" class="titleList" style="color: rgb(153, 153, 153); float: right;">
                            <span class="fa fa-music" style="font-size: 22px; vertical-align: middle;"></span>
                            <span style="padding-left: 6px;">音乐播放</span>
                        </div>
                        <div  v-on:click="ship1(ships)" class="titleList" style="color: rgb(153, 153, 153); float: right;">
                            <span class="fa fa-play-circle" style="font-size: 22px; vertical-align: middle;"></span>
                            <span style="padding-left: 6px;">视频演示</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12" style="padding-left: 4px">

                    <div class="titleListBox">
                        <div class="titleList" style="cursor: auto;">
                            <span>再见仪式</span>
                        </div>
                        <div :aud="audioe" v-on:click="yin1($event)" class="titleList" style="color: rgb(153, 153, 153); float: right;">
                            <span class="fa fa-music" style="font-size: 22px; vertical-align: middle;"></span>
                            <span style="padding-left: 6px;">音乐播放</span>
                        </div>
                        <div class="titleList" v-on:click="ship1(shipe)" style="color: rgb(153, 153, 153); float: right;">
                            <span class="fa fa-play-circle" style="font-size: 22px; vertical-align: middle;"></span>
                            <span style="padding-left: 6px;">视频演示</span>
                        </div>
                    </div>

                </el-col>

            </el-row>

            <el-row>
                <el-col :span="24" style="margin-top: 5px" v-for="(fen,index) in fendata" :key="index">
                    <div class="zhengwen">
                        <div class="fix" >
                        <p style="float: left" class="title11" >{{index+1}} <span>.</span> {{fen.title}}</p>
                            <div class="titleList" @click="ship1(fen.process_video)" v-if="fen.process_video" style="float: right;width: 16.66%;color: #999">
                                <span style="font-size:22px;vertical-align: middle;" class="fa fa-play-circle"></span>
                                <span style="padding-left:6px ">视频演示</span>
                            </div>
                        <div class=" titleList" v-on:click="yin1($event)" v-if="fen.process_audio_vid" :aud="fen.process_audio_vid"  style="float: right;width: 16.66%;color: #999">
                            <span style="font-size:22px;vertical-align: middle;" class="fa fa-music"></span>
                            <span style="padding-left:6px ">音乐播放</span>
                        </div>

                     </div>
                     <div class="neirong11" v-html="fen.process"></div>
                    </div>
                </el-col>
            </el-row>
        </el-col>
    </el-row>
</div>


    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="background:rgba(0,0,0,0.3) ">
        <div class="modal-dialog" role="document" style="width:900px">
            <div class="modal-content" >
                <div class="modal-body" >
                    <div aria-hidden="true" v-on:click="guans" style="float: right;cursor: pointer">&times;</div>
					<div style="clear: both;"></div>
                    <div style="margin-top:0px">
                        <div id="myVideo"></div>
                    </div>
                    <!--<video id="myVideo" controls style="width: 100%" :src="shipp"></video>-->
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="myModa2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="background:rgba(0,0,0,0.3) ">
        <div class="modal-dialog" role="document" style="width:600px;margin-top: 15%;">
            <div class="modal-content" >
                <div class="modal-body" style="padding:10px;" id='yinp'>
                    <div aria-hidden="true" v-on:click="guans2" style="float: right;cursor: pointer;font-size:25px;">&times;</div>
                    <div style="clear: both;"></div>
						<div style="margin-top:0px">
						    <div id="myaudio"></div>
						</div>

                </div>
            </div>
        </div>
    </div>



</div>
</template>

<script>
    export default {
        data() {
            return{
                kecheng2:'全部体系',
                title:'',
                kechengname:'',
                iid:'',
                kcid:'',
                quanke1:'',
                quanke2:'',
                is_sc:0,
                is_bk:0,
                ydrs:'',
                shouc:'',
                zhengwen:'',
                re_id:'',
                shipp:'',
                ships:'',
                shipe:'',
                audios:'',
                audioe:'',
                fendata:'',
                audio:'',
                play_auth:'',
                player:'',
                player0:'',
                banben:[],
                jiaoid:'',
                ckindex:'',
                active2_index:0,
                token:'',
                start_time:'',
                end_time:''
            }
        },
        methods: {
            ke1(id){
                let self=this;
                self.kcid=id
                $.ajax({
                    url:process.env.apiUrl + "saas/jiaoan/qbja",
                    type:"post",
                    dataType:'json',
                    data:{
                        kc_id:id,
                        token:self.token
                    },
                    success:function(data){
                        self.quanke2=data.data
                    }
                });
            },
            ke2(id1){
                let self=this;
                self.iid=id1;
                $.ajax({
                    url:process.env.apiUrl + "saas/jiaoan/deta",
                    type:"post",
                    dataType:'json',
                    data:{
                        id:id1,
                        token:self.token
                    },
                    success:function(data){
                        self.iid=data.data.zong.id;
                        self.title=data.data.zong.title;
                        self.kechengname=data.data.zong.kc_name;
                        self.is_sc=data.data.zong.is_sc;
                        self.is_bk=data.data.zong.is_bk;
                        self.ydrs=data.data.zong.ydrs;
                        self.shouc=data.data.zong.sc;
                        self.zhengwen=data.data.zong.process;
                        self.re_id=data.data.zong.re_id;
                        self.audios=data.data.zong.start_vid;
                        self.audioe=data.data.zong.end_vid;
                        self.ships=data.data.zong.start_video;
                        self.shipe=data.data.zong.end_video;
                        self.fendata=data.data.fen;

                    }
                })
            },
            guans:function () {
                if(self.player){
                    self.player.dispose();
                }

                $('#myVideo').empty();
                $('#myModal').modal('hide')
            },
            guans2:function () {
				if(self.player0){
				    self.player0.dispose();
				}

				$('#myaudio').empty();
				$('#myModa2').modal('hide')
            },
            yin1:function (ev) {
                var self=this;
                var el = ev.currentTarget;
                self.audio=$(el).attr("aud");
                $.ajax({
                    url:process.env.apiUrl + "saas/jiaoan/getplayauth",
                    type:"post",
                    dataType:'json',
                    data:{
                        vid:self.audio,
                        token:self.token
                    },
                    success:function(data){
                        self.play_auth=data.play_auth;
                       $('#myModa2').modal({"backdrop":"static"})
                        if(self.player0){
                            self.player0.dispose();
                        }
                        $('#myaudio').empty();
                        setTimeout(function () {
                            self.player0 = Aliplayer(
                                {
									id: "myaudio",
									autoplay: true,
									width: "580px",
									height: "100px",
									vid:self.audio,
									playauth: self.play_auth,
									mediaType:"audio",
									controlBarVisibility:'always',
                                });
                        },10)

                    }
                });

            },
            ship1:function (v) {
                var self = this
                self.shipp=v;
                console.log(self.shipp)
                $.ajax({
                    url:process.env.apiUrl + "saas/jiaoan/getplayauth",
                    type:"post",
                    dataType:'json',
                    data:{
                        vid:v,
                        token:self.token
                    },
                    success:function(data){

                        self.play_auth=data.play_auth;
                        console.log(v+'\n'+self.play_auth)
                        $('#myModal').modal({"backdrop":"static"});

                        if(self.player){
                            self.player.dispose();
                        }
                        $('#myVideo').empty();
                        setTimeout(function () {
                            self.player = Aliplayer(
                                {id: "myVideo",
                                    autoplay: true,
                                    width: "868px",
                                    height: "460px",
                                    vid: v,
                                    playauth: self.play_auth
                                });
                        },10)

                    }
                });

            },
            wanb:function () {
                var self=this;
                $.ajax({
                    url:process.env.apiUrl + "saas/jiaoan/wcbk",
                    type:"post",
                    dataType:'json',
                    data:{
                        id:self.iid,
                        token:self.token
                    },
                    success:function(data){
                        if(data.status==1){
                            self.is_bk=1
                        }
                    }
                });
            },
            shez:function () {
                var self=this;
                $.ajax({
                    url:process.env.apiUrl + "saas/jiaoan/swzd",
                    type:"post",
                    dataType:'json',
                    data:{
                        id:self.iid,
                        token:self.token
                    },
                    success:function(data){
                        if(data.status==1){
                            self.is_sc=1
                        }

                    }
                });

            },

            shai:function (status) {
                var self=this;
                if(status==1){
                    this.kecheng2="未备课"
                }else if(status==2){
                    this.kecheng2="已完成"
                }

                $.ajax({
                    url:process.env.apiUrl + "saas/jiaoan/wbk",
                    type:"post",
                    dataType:'json',
                    data:{
                        status:status,
                        kc_id:self.kcid,
                        token:self.token
                    },
                    success:function(data){
                        self.quanke2=data.data

                    }
                });
            },
        },
        mounted:function () {
            let self=this;
            self.token=self.$cookies.get('token');
            self.jiaoid=self.$route.query.jiaoid;
            self.start_time = self.$route.query.start_time;
            self.end_time = self.$route.query.end_time;
            self.kcid = self.$route.query.kc_id;
            $.ajax({
                url:process.env.apiUrl + "saas/jiaoan/edition",
                type:"post",
                dataType:'json',
                data:{
                    id:self.jiaoid,
                    token:self.token
                },
                success:function(data){
                   // self.banben=data;
                   // var banxuan='';
                   // for(var i =0;i<data.length;i++){
                   //     if(data[i].default==1){
                   //         self.ckindex=i
                   //     }
                   // }
                }
            });

            $.ajax({
                url:process.env.apiUrl + "saas/jiaoan/deta",
                type:"post",
                dataType:'json',
                data:{
                    id:self.jiaoid,
                    token:self.token
                },
                success:function(data){
                    // self.kcid=data.data.zong.kc_id;
                    console.log(self.kcid)
                    self.iid=data.data.zong.id;
                    self.title=data.data.zong.title;
                    self.kechengname=data.data.zong.kc_name;
                    self.is_sc=data.data.zong.is_sc;
                    self.is_bk=data.data.zong.is_bk;
                    self.ydrs=data.data.zong.ydrs;
                    self.shouc=data.data.zong.sc;
                    self.zhengwen=data.data.zong.process;
                    self.re_id=data.data.zong.re_id;
                    self.ships=data.data.zong.start_video;
                    self.shipe=data.data.zong.end_video;
                    self.audios=data.data.zong.start_vid;
                    self.audioe=data.data.zong.end_vid;
                    self.fendata=data.data.fen;

                    $.ajax({
                        url:process.env.apiUrl + "saas/jiaoan/qbkc",
                        type:"post",
                        dataType:'json',
                        data:{
                            kc_id:self.kcid,
                            token:self.token,
                            start_time:self.start_time,
                            end_time:self.end_time
                        },
                        success:function(data){
                            self.quanke1=data.data
                        }
                    });
                    $.ajax({
                        url:process.env.apiUrl + "saas/jiaoan/qbja",
                        type:"post",
                        dataType:'json',
                        data:{
                            kc_id:self.kcid,
                            token:self.token
                        },
                        success:function(data){
                            self.quanke2=data.data
                        }
                    });
                }
            });
        }
    }
</script>
<style scoped>
    #jiaoanx *{
        box-sizing: border-box;
    }
    #jiaoanx  p,ul,label{
        padding: 0;
        margin: 0;
    }
    #jiaoanx  .kezhuang2 {
        background: #ff797c;
        color: #fff;
    }
    .dropm2 {
        border: 1px solid #79c4c7;
        border-radius: 0 0 5px 5px;
    }
    .dropm1, .dropm2 {
        width: 100%;
        padding: 0;
        border: 1px solid #79c4c7;
        border-radius: 0 0 5px 5px;
    }
    .dropm1 li {
        border-bottom: 1px solid #79c4c7;
        box-sizing: border-box;
        height: 32px;
        line-height: 32px;
        text-align: center;
    }
    body .dropdown-menu>li>a {
        line-height: 32px;
        box-sizing: border-box;
    }
    .dropdown-menu>li>a {
        display: block;
        padding: 0;
    }
    #jiaoanx .caret{
        color: #fff;
    }
    #jiaoanx  .btna {
        display: inline-block;
        padding: 6px 12px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
    }
    #jiaoanx{
        box-sizing: border-box;
    }
   #jiaoanx *{
        font-size:14px;
        box-sizing: border-box;
    }
    .bodybox{
        background: rgb(237, 237, 237);
        min-height: 100%;
        overflow-y: scroll;
    }
    .dropbox{
        width: 100%;
        height:34px;
        line-height: 34px;
        color: #fff;
        background: rgb(0, 204, 228);
        text-align: center;
        border-radius: 4px;
    }
        .dropbox2{
            width: 100%;
            height:34px;
            line-height: 34px;
            color: #fff;
            background: rgb(255, 121, 124);
            text-align: center;
            border-radius: 4px;
        }
        .kelist {
            cursor: pointer;
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: rgb(153, 153, 153);
            margin-bottom: 3px;
            background: rgb(255, 255, 255);
            border-radius: 5px;
        }
        .hang1 {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
        .active1 {
            color: rgb(0, 204, 228);
            box-shadow: rgb(138, 227, 237) 0px 3px 10px;
        }
        .active2 {
            color: rgb(255, 121, 124);
            box-shadow: rgb(233, 175, 176) 0px 3px 10px;
        }
        .text-center{
            text-align: center;
        }
    .jiaoxt{
        height: 85px;
        line-height: 85px;
        border-radius: 10px;
        background: rgb(255, 255, 255);
    }
    .conTitle {
        font-size: 20px;
        margin-bottom: 4px;
    }
    .zidBtn {
        height: 30px;
        width: 104px;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        color: rgb(255, 255, 255);
        cursor: pointer;
        border-radius: 15px;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        margin: 30px 20px 0px 0px;

    }
    .zidy {
        background: rgb(0, 204, 228);
    }
    .zidg {
        background: rgb(255, 121, 124);
    }
    .btn_back{
        background-color: gainsboro;
        color: gray;
    }

    em, i {
        font-style: normal;
        font-weight: normal;
    }
    .titleListBox {

        border-radius: 10px;
        background: #fff;
        display: flex;
        display: -webkit-flex;
    }
    .titleList {

        width: 33.33%;
        height: 50px;
        line-height: 50px;
        padding-left: 22px;
    }
    .fa.fa-music,.fa.fa-play-circle{
        color: #E6BE8A;
    }
    .zhengwen {
        background: #fff;
        border-radius: 10px;
        padding-left: 10px;
        margin-bottom: 4px;
    }
    .title11 {
        line-height: 50px;
        font-size: 18px;
    }
    .neirong11 {
        padding-left: 15px;
        padding-right: 15px;
        padding-bottom: 10px;
    }
</style>
<style>
    #jiaoanx  p,ul,label{
        padding: 0;
        margin: 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/jiaoan/jiaoanx.vue